import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'app-notcontent',
	templateUrl: './notcontent.component.html',
	styles: []
})
export class NotcontentComponent {
	@Input() type:string = '';
}
